module.exports = __webpack_public_path__ + "img/weiyifan.1ddff7f9.png";